import { RootState } from '../index';

export const accountDataSelector = (state: RootState) => state.auth.accountData;
export const userNameSelector = (state: RootState) => accountDataSelector(state)?.user.email;
